const explicitApiUrl = process.env.REACT_APP_RELEASES_API_URL;
const isProduction = process.env.NODE_ENV === 'production';
const isTestEnv = process.env.REACT_APP_IS_TEST_ENV === 'true';
const isTestFromBackendUrl = process.env.REACT_APP_URL_BACKEND_API?.includes('test.medbioinformatics.com');

const RELEASES_API_URL =
  explicitApiUrl ||
  (isProduction && !isTestEnv && !isTestFromBackendUrl
    ? process.env.REACT_APP_RELEASES_API_URL_PROD || 'https://fpg128xyga.execute-api.eu-central-1.amazonaws.com'
    : process.env.REACT_APP_RELEASES_API_URL_TEST || 'https://fpg128xyga.execute-api.eu-central-1.amazonaws.com');

export interface ApiReleaseFileMeta {
  key: string;
  url: string;
  lastModified: string;
  size: number;
  releaseDate?: string;
}

export interface ApiReleaseListItem {
  version: string;
  files: {
    statistics: ApiReleaseFileMeta | null;
    changelog: ApiReleaseFileMeta | null;
    gdasStats?: ApiReleaseFileMeta | null;
    vdasStats?: ApiReleaseFileMeta | null;
  };
}

export interface ApiReleaseStatisticsEntry {
  dataset: string;
  count: number;
}

export interface ApiChangelogEntry {
  Version: string;
  Section: string;
  Text: string;
  releaseDate: string;
  gda_summary?: string;
  vda_summary?: string;
}

export interface ApiGdasStatsEntry {
  source: string;
  genes: number;
  diseases: number;
  gdas: number;
  Gassocs: number;
  Gpapers: number;
  Gchemicals: number;
  [key: string]: string | number;
}

export interface ApiVdasStatsEntry {
  source: string;
  variants: number;
  Vdiseases: number;
  vdas: number;
  Vassocs: number;
  Vpapers: number;
  Vchemicals: number;
  [key: string]: string | number;
}

export interface ApiReleaseDetail {
  version: string;
  files: ApiReleaseListItem['files'];
  releaseDate?: string;
  statistics: ApiReleaseStatisticsEntry[] | null;
  changelog: ApiChangelogEntry[] | null;
  gdasStats?: ApiGdasStatsEntry[] | null;
  vdasStats?: ApiVdasStatsEntry[] | null;
}

async function getReleasesList(): Promise<ApiReleaseListItem[]> {
  const res = await fetch(`${RELEASES_API_URL}/releases`, {
    method: 'GET',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) {
    throw new Error(`Releases API error: ${res.status}`);
  }
  const data = await res.json();
  return data.releases ?? [];
}

async function getRelease(version: string): Promise<ApiReleaseDetail> {
  const res = await fetch(
    `${RELEASES_API_URL}/releases/${encodeURIComponent(version)}`,
    {
      method: 'GET',
      headers: { Accept: 'application/json' },
    }
  );
  if (!res.ok) {
    throw new Error(`Release ${version} API error: ${res.status}`);
  }
  return res.json();
}

export const releasesApiService = {
  getReleasesList,
  getRelease,
  getBaseUrl: () => RELEASES_API_URL,
};

export default releasesApiService;
